import { Component, Input, OnInit } from '@angular/core';
import { UpdateComponent } from '@app/shared/components/base/update.component';
import { DrI18nService } from '@app/core/services/i18n/i18n.service';
import { ErrorStateMatcher } from '@angular/material/core';
import { UntypedFormControl } from '@angular/forms';
import { OP, OpData } from '@app/core/services/base/base-service-with-bundle.service';
import { marker } from '@biesbjerg/ngx-translate-extract-marker';

export interface DateTimePickerOptions {
  datePatchPath: string;
  timePatchPath: string;
  dateLabel?: string;
  timeLabel?: string;
}

export class DatePickerErrorStateMatcher implements ErrorStateMatcher {
  private control: UntypedFormControl;
  public validateMe: boolean;
  public inError: boolean;

  public isErrorState(control: UntypedFormControl | null): boolean {
    if (!this.control) {
      this.control = control;
    }

    this.inError = this.validateMe && control && control.value && control.value.length !== 5;
    return this.inError;
  }

  public validate(): boolean {
    this.validateMe = true;
    return !this.isErrorState(this.control);
  }
}

@Component({
  selector: 'date-time-picker',
  templateUrl: './date-time-picker.component.html',
  styleUrls: ['./date-time-picker.component.scss']
})
export class DateTimePickerComponent extends UpdateComponent implements OnInit {

  protected defaultOptions = {
    dateLabel: marker('common.label.date'),
    timeLabel: marker('common.label.time')
  };

  public mergedOptions: DateTimePickerOptions;
  public matcher: DatePickerErrorStateMatcher;

  @Input()
  protected options: DateTimePickerOptions;

  @Input()
  public date: Date;

  @Input()
  public time: string;

  constructor() {
    super();
  }

  public ngOnInit() {
    super.ngOnInit();
    this.matcher = new DatePickerErrorStateMatcher();
    this.mergeOptions();
  }

  protected mergeOptions(): void {
    this.mergedOptions = {
      datePatchPath: this.options && this.options.datePatchPath,
      timePatchPath: this.options && this.options.timePatchPath,
      dateLabel: this.options && this.options.dateLabel ? this.options.dateLabel : this.defaultOptions.dateLabel,
      timeLabel: this.options && this.options.timeLabel ? this.options.timeLabel : this.defaultOptions.timeLabel,
    };
  }
  
  public onUpdateTime(): void {
    if (this.matcher.validate()) {
      if (this.time && !this.date) {
        this.date = new Date();
      }

      this.sendUpdate();
    }
  }

  public onTimeFieldFocus(): void {
    this.matcher.validateMe = false;
  }

  public sendUpdate() {
    if (this.matcher.validate()) {
      const opArray = new Array<OpData>();
      opArray.push({
        op: this.date ? OP.replace : OP.remove,
        path: this.mergedOptions.datePatchPath,
        value: this.date ? DrI18nService.dateTimeToDateOnlyString(this.date) : undefined
      });

      opArray.push({
        op: this.time ? OP.replace : OP.remove,
        path: this.mergedOptions.timePatchPath,
        value: this.time || undefined
      });

      this.onMultiUpdate(opArray);
    }
  }
}
